import { Card, CardActionArea, Chip, Box, Typography } from "@mui/material";

import { type BlueprintMessage } from "@/types/creativesphere";

export type BlueprintCardProps = {
  onSelect: (blueprint: BlueprintMessage) => void;
  blueprint: BlueprintMessage;
};

// display the blueprint thumbnaiil url in the card
export function BlueprintCard({ blueprint, onSelect }: BlueprintCardProps) {
  return (
    <Card variant="outlined" sx={{ maxWidth: 420 }}>
      <CardActionArea
        onClick={() => onSelect(blueprint)}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          gap: 2,
          p: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Typography variant="subtitle1">{blueprint.name}</Typography>
          <Chip
            label="Recommended"
            size="small"
            color="primary"
            variant="outlined"
          />
        </Box>
        <Box
          {...(blueprint.thumbnail_url
            ? {
                component: "img",
                src: blueprint.thumbnail_url,
                alt: blueprint.name,
              }
            : {})}
          sx={{
            bgcolor: "action.hover",
            borderRadius: 1,
            height: 200,
            width: "100%",
            objectFit: "cover",
          }}
        />
      </CardActionArea>
    </Card>
  );
}
